// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"193":"b5a3ef2a85a59034","750":"c121e52dd5ba479b","995":"51851e0939bdcd24"}[chunkId] + ".js";
};